import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-deptenquirydetails-form',
  templateUrl: './deptenquirydetails-form.component.html',
  styleUrls: ['./deptenquirydetails-form.component.css']
})
export class DeptenquirydetailsFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/serviceregister/deptenquirydetails/deptenquirydetails-form/deptenquirydetails-form.component.ts